import { useQuery } from "@tanstack/react-query";
import { getPatientMedicalHistory } from "apis";
import useGetWhoAmI from "../aorta/who-am-i";

const useGetPatientHistory = ({ patientOid }: { patientOid: string }) => {
  const { data } = useGetWhoAmI();
  const doctorOid = data?.["doc-id"];
  return useQuery(
    getPatientHistoryQueryKeys({
      doctorOid: doctorOid,
      patientOid: patientOid,
    }),
    () =>
      getPatientMedicalHistory({
        doctorOid: doctorOid!,
        patientOid: patientOid!,
      }),
    {
      enabled: !!doctorOid && !!patientOid,
    }
  );
};

export default useGetPatientHistory;

export function getPatientHistoryQueryKeys({
  doctorOid,
  patientOid,
}: {
  doctorOid?: string;
  patientOid?: string;
}) {
  const key = [`get-patient-history`];
  if (doctorOid) {
    key.push(doctorOid);
  }
  if (patientOid) {
    key.push(patientOid);
  }
  return key;
}
